import {TimeEntry} from '@package/shared'
import type {z} from 'zod'

export const TimeEntryFormValues = TimeEntry.pick({
  start: true,
  end: true,
  breakHours: true,
  description: true,
  projectId: true,
})
export type TimeEntryFormValues = z.infer<typeof TimeEntryFormValues>
